import { Box, CircularProgress, Container } from "@mui/material";
import Text from "../ui/Text";

export const LoadingSpinner = ({ sx }) => (
  <Container>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 10,
        gap: 2,
        ...sx,
      }}
    >
      <CircularProgress size={40} />
      <Text variant="paragraph3" sx={{ color: "#666" }}>
        Loading...
      </Text>
    </Box>
  </Container>
);
